import { createFileRoute } from "@tanstack/react-router";
import { MessageCircle, Youtube, MapPin, MousePointer, Instagram, Phone } from "lucide-react";

import { carregarPaginaSimples } from "@/lib/pagina-simples";

const BOTOES = [
  {
    texto: "Contato pelo WhatsApp",
    href: "https://tintim.link/whatsapp/275998d7-8dfa-42e4-ac35-593820cbf261/b14df285-e546-493c-ae33-959a045e923e",
    Icone: MessageCircle,
  },
  { texto: "Ligue Agora", href: "tel:14998220707", Icone: null },
  { texto: "Youtube", href: "https://www.youtube.com/@drthiagoviana", Icone: Youtube },
  {
    texto: "Localizacão",
    href: "https://maps.google.com/?cid=13509211634599351926",
    Icone: MapPin,
  },
  { texto: "Site Oficial", href: "https://drthiagoviana.com/", Icone: MousePointer },
  {
    texto: "Spotify",
    href: "https://open.spotify.com/show/3Kbi82amCpVjAqzYqFmdTL",
    Icone: MessageCircle,
  },
  { texto: "Instagram", href: "https://www.instagram.com/drthiagoviana/", Icone: Instagram },
] as const;

export const Route = createFileRoute("/links")({
  loader: () =>
    carregarPaginaSimples(
      "/links/",
      "ITV Saúde, Bem-Estar e Estética | Dr. Thiago Viana em Bauru",
      "Todos os canais de contato do Dr. Thiago Viana em Bauru: WhatsApp, telefone, localização do consultório, site oficial, YouTube, Spotify e Instagram.",
    ),
  head: ({ loaderData }) => ({ meta: loaderData?.meta ?? [], links: loaderData?.links ?? [] }),
  component: PaginaLinks,
});

function PaginaLinks() {
  return (
    <div className="legado">
      <section className="links-pagina">
        <div className="links-fundo">
          <img src="/imagens/lp/bg-desk.png" alt="" width={1920} height={900} />
        </div>
        <div className="links-conteudo">
          <img
            className="links-logo"
            src="/imagens/lp/dr_thiago_viana_logomarca2-scaled-1.png"
            alt="ITV Saúde, Bem-Estar e Estética"
            width={2560}
            height={1929}
          />
          <h1 className="sr-only">ITV Saúde, Bem-Estar e Estética | Dr. Thiago Viana em Bauru</h1>
          <p className="links-sub">
            Experimente um cuidado personalizado com tecnologias modernas com foco em saúde à longo
            prazo e qualidade de vida.
          </p>
          {BOTOES.map(({ texto, href, Icone }) => (
            <a className="links-botao" key={texto} href={href}>

              {texto}
              {Icone ? <Icone size={18} aria-hidden="true" /> : null}
            </a>
          ))}
          <p className="links-endereco">
            Av. Getúlio Vargas, 22-25 - Sala 7 - Torre 2 -<br />
            Jardim Europa, Bauru - SP.
          </p>
          <p className="links-tel">
            <Phone size={15} aria-hidden="true" /> (14) 99822-0707
          </p>
        </div>
      </section>
    </div>
  );
}
